// // import modules from './modules';
// import { lazy } from "react";
// //import './App.css'
// const fetch = require('sync-fetch');
// let App, domain, portal_id, prev_url, location, path_split, prefix, url;

// domain = window.location.hostname == 'localhost'? 'eum.tespire.co' : window.location.hostname;
// url =( window.location.hostname == 'localhost' || domain == 'eum.tespire.co') ? 'https://api-staging.tespire.ng/api/school-info' : 'https://api.tespire.ng/api/school-info';
// // const school = useSelector((state) => state.school.value);

// let school = sessionStorage.getItem('school') != undefined ? JSON.parse(sessionStorage.getItem('school')) : fetch(url, { headers: { xtenant: domain } }).json();

// const Application = lazy(() => import("./modules/ApplicationPortal"));
// const SecuredPanel = lazy(() => import("./modules/SecuredPanel"));
// const Students = lazy(() => import("./modules/StudentsPortal"));
// const GenLanding = lazy(() => import("./global-components/landing"));
// //This file is temporarily not in use
// // The plan is to use this file to dynamically render portals



// let portal_ids = [];



// school?.portals?.map((portal,i) => {
//     portal_ids?.push(portal.portal_id)
// });

// prev_url = document.referrer;

// location = window.location.pathname;

// path_split = location.split("/");
// prefix = path_split[1];


// if (!domain.match(/application|students|securedpanel/g) && location == '/' && !prev_url.includes('/auth/login')) {
//     domain = location;
//     sessionStorage.removeItem('portal_id');
// }

// portal_id = sessionStorage.getItem('portal_id') ?? null;

// if (prefix.includes('application') || portal_id == '1') {
//     App = Application;
//     portal_id = '1';
// } else if (prefix.includes('students') || portal_id == '2') {
//     App = Students;
//     portal_id = '2';
// } else if (prefix.includes('securedpanel') || portal_id == '3') {
//     App = SecuredPanel;
//     portal_id = '3';
// } else if (domain == '/') {   
//     App = GenLanding; 
// }

// if (!(portal_ids?.includes(portal_id) || portal_ids?.includes(parseInt(portal_id)))) {
//     App = GenLanding;
// }



import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Application = lazy(() => import('./modules/ApplicationPortal'));
const SecuredPanel = lazy(() => import('./modules/SecuredPanel'));
const Students = lazy(() => import('./modules/StudentsPortal'));
const GenLanding = lazy(() => import('./global-components/landing'));
const DomainNotTaken = lazy(() => import('./global-components/DomainNotTaken'));
const ShowInactive = lazy(() =>
  import('./global-components/InactiveComponent').then((m) => ({ default: m.ShowInactive }))
);

// portal_id -> route config, replacing the old prefix.includes(...) checks
const PORTAL_ROUTES = {
  1: { path: '/applicationportal/*', Component: Application },
  2: { path: '/studentsportal/*', Component: Students },
  3: { path: '/securedpanel/*', Component: SecuredPanel },
};

export default function App({ school }) {
  if (school?.status === false) return <DomainNotTaken />;
  if (school?.status === 'inactive') return <ShowInactive />;

  const allowedPortalIds = (school?.portals ?? []).map((p) => String(p.portal_id));


  return (
    <Routes>
      {Object.entries(PORTAL_ROUTES)
        .filter(([id]) => allowedPortalIds.includes(id))
        .map(([id, { path, Component }]) => (
          <Route key={id} path={path} element={<Component />} />
        ))}
      <Route path="*" element={<GenLanding />} />
    </Routes>
  );
}



